import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { appActions } from '../../../store';
import styles from './SurfaceMenuItem.module.css';
import { getThumbnailUrl } from '../../../Helpers/ThumbHelper';
import { getSwatchUrl } from '../../../Helpers/PatternHelper';
import edit from './assets/edit.svg';

export default function SurfaceMenuItem() {
    const dispatch = useDispatch();
    const chosenPattern = useSelector(state => state.app.chosenPattern);
    const style = useSelector(state => state.app.style);
    const size = useSelector(state => state.app.size);
    const patternColors = useSelector(state => state.app.patternColors);
    
    const [swatchUrl, setSwatchUrl] = useState(null);

    // Update swatchUrl when patternColors changes (including when updatePatternColor is called)
    useEffect(() => {
        const url = getSwatchUrl(chosenPattern, patternColors) || getThumbnailUrl(chosenPattern);
        setSwatchUrl(url);
    }, [chosenPattern, patternColors]);

    if (!chosenPattern) return null;

    const handleImageClick = () => {
        dispatch(appActions.setMenuActiveTab('rug'));
        dispatch(appActions.setMenuActiveSection('pattern'));
    };

    return (
        <div className={styles.surfaceMenu}>
            <div className={styles.groupDiv}>
                <div 
                    className={styles.thumbWrapper}
                    onClick={handleImageClick}
                    style={{ cursor: 'pointer' }}
                >
                    <span className={styles.editOverlay}>
                        <img src={edit} alt="edit" />
                    </span>
                    {swatchUrl ? (
                        <img
                            src={swatchUrl}
                            alt={`${style} - ${size}`}
                            className={styles.thumbImg}
                        />
                    ) : (
                        <div className={styles.thumbPlaceholder} />
                    )}
                </div>
                <div className={styles.details}>
                    <p className={styles.patternName}>{style || 'Pattern'}</p>
                    <p className={styles.patternSize}>{chosenPattern.descriptor}</p>
                    <p className={styles.colorCount}>{chosenPattern.description} colors</p>
                   
                </div>
            </div>
        </div>
    );
}
